module.exports = __webpack_public_path__ + "img/nose.5590ff47.gif";